import _ from "lodash";
import type { PatchedAdminHealthAndSafety } from "@/api/model";
import * as formatters from "@/modules/profile/utils/formatters";
import type { HealthSafetyFormRows } from "../components/sections";

export class CollapsableHealthAndSafetyPatchDTO
  implements PatchedAdminHealthAndSafety
{
  emergency_contact_1_name?: PatchedAdminHealthAndSafety["emergency_contact_1_name"];
  emergency_contact_1_email?: PatchedAdminHealthAndSafety["emergency_contact_1_email"];
  emergency_contact_1_phone?: PatchedAdminHealthAndSafety["emergency_contact_1_phone"];
  emergency_contact_2_name?: PatchedAdminHealthAndSafety["emergency_contact_2_name"];
  emergency_contact_2_email?: PatchedAdminHealthAndSafety["emergency_contact_2_email"];
  emergency_contact_2_phone?: PatchedAdminHealthAndSafety["emergency_contact_2_phone"];
  medical_conditions?: PatchedAdminHealthAndSafety["medical_conditions"];
  allergies?: PatchedAdminHealthAndSafety["allergies"];
  dietary_restrictions?: PatchedAdminHealthAndSafety["dietary_restrictions"];
  current_injuries?: PatchedAdminHealthAndSafety["current_injuries"];

  constructor(data: PatchedAdminHealthAndSafety) {
    this.emergency_contact_1_name = data.emergency_contact_1_name;
    this.emergency_contact_1_email = data.emergency_contact_1_email;
    this.emergency_contact_1_phone = data.emergency_contact_1_phone;
    this.emergency_contact_2_name = data.emergency_contact_2_name;
    this.emergency_contact_2_email = data.emergency_contact_2_email;
    this.emergency_contact_2_phone = data.emergency_contact_2_phone;
    this.medical_conditions = data.medical_conditions;
    this.allergies = data.allergies;
    this.dietary_restrictions = data.dietary_restrictions;
    this.current_injuries = data.current_injuries;
  }

  toJSON(): PatchedAdminHealthAndSafety {
    return _.omitBy(this, _.isNil);
  }
}

export const healthAndSafetyRequestModelToViewModel = (
  requestModel: PatchedAdminHealthAndSafety | null | undefined
): HealthSafetyFormRows => ({
  emergencyContact1Name: {
    label: "Emergency Contact 1 Name",
    data: requestModel?.emergency_contact_1_name,
    lastUpdated: formatters.formatDisplayDate(
      requestModel?.emergency_contact_1_name_updated_at
    ),
  },
  emergencyContact1Email: {
    label: "Emergency Contact 1 Email",
    data: requestModel?.emergency_contact_1_email,
    lastUpdated: formatters.formatDisplayDate(
      requestModel?.emergency_contact_1_email_updated_at
    ),
  },
  emergencyContact1Phone: {
    label: "Emergency Contact 1 Phone",
    data: requestModel?.emergency_contact_1_phone,
    lastUpdated: formatters.formatDisplayDate(
      requestModel?.emergency_contact_1_phone_updated_at
    ),
  },
  emergencyContact2Name: {
    label: "Emergency Contact 2 Name",
    data: requestModel?.emergency_contact_2_name,
    lastUpdated: formatters.formatDisplayDate(
      requestModel?.emergency_contact_2_name_updated_at
    ),
  },
  emergencyContact2Email: {
    label: "Emergency Contact 2 Email",
    data: requestModel?.emergency_contact_2_email,
    lastUpdated: formatters.formatDisplayDate(
      requestModel?.emergency_contact_2_email_updated_at
    ),
  },
  emergencyContact2Phone: {
    label: "Emergency Contact 2 Phone",
    data: requestModel?.emergency_contact_2_phone,
    lastUpdated: formatters.formatDisplayDate(
      requestModel?.emergency_contact_2_phone_updated_at
    ),
  },
  medicalConditions: {
    label: "Medical Conditions",
    data: requestModel?.medical_conditions,
    lastUpdated: formatters.formatDisplayDate(
      requestModel?.medical_conditions_updated_at
    ),
  },
  allergies: {
    label: "Allergies",
    data: requestModel?.allergies,
    lastUpdated: formatters.formatDisplayDate(
      requestModel?.allergies_updated_at
    ),
  },
  dietaryRestrictions: {
    label: "Dietary Restrictions",
    data: requestModel?.dietary_restrictions,
    lastUpdated: formatters.formatDisplayDate(
      requestModel?.dietary_restrictions_updated_at
    ),
  },
  currentInjuries: {
    label: "Current Injuries",
    data: requestModel?.current_injuries,
    lastUpdated: formatters.formatDisplayDate(
      requestModel?.current_injuries_updated_at
    ),
  },
});
